module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10251.99ab9c9e.jpg";